import { MLM, MsTracking, NOT_SET, TrackingParameter, TrackingType, addTracking, track } from '@sunrise/tracking'

import { ActionIds, MLMData } from '../../../ts/tracking/mlmActionIds.enum'
import { staticMlmTrackingData } from '../../../ts/tracking/mlmStaticTrackingData'
import { TealiumTrackingIds } from '../../../ts/tracking/tealiumTrackingIds.enum'
import { getCompanyName, getTypePaid } from '../../../ts/utils/trackingUtils'

export function createMlmViewTracking(
    isExternalReferer: boolean,
    componentId: string,
    currentUrl: string,
    exposeeId: number,
    ownInventory: boolean,
): Record<string, string> | undefined {
    const mlmTrackingData: MsTracking = buildMlmViewTrackingData(componentId, currentUrl, exposeeId, ownInventory)

    return isExternalReferer ? addTracking([mlmTrackingData]) : undefined
}

export function mlmTrackDirectEntryClick(
    componentId: string,
    currentUrl: string,
    exposeeId: number,
    ownInventory: boolean,
): void {
    const trackingData: MLM.TrackingData = buildMlmClickTrackingData(componentId, currentUrl, exposeeId, ownInventory)
    MLM.trackClick(trackingData)
}

export function trackFinancingLinkClick(exposeeId: number): void {
    const trackingData: TrackingParameter = buildTealiumFinanceLinkData(exposeeId)
    track(trackingData)
}

export function trackMapAnchorClick(exposeeId: number): void {
    const trackingData: TrackingParameter = buildMapAnchorTrackingData(exposeeId)
    track(trackingData)
}

function buildMlmViewTrackingData(
    componentId: string,
    currentUrl: string,
    exposeeId: number,
    ownInventory: boolean,
): MsTracking {
    return MLM.createMlmTracking(
        {
            ...staticMlmTrackingData,
            page: MLMData.DEFAULT_PAGE as number,
            actionId: ActionIds.PAGE_VIEW,
            componentId,
            pageUrl: currentUrl,
            items: [buildMlmItems(exposeeId, ownInventory)],
        },
        TrackingType.PAGE_VIEW,
    )
}

function buildMlmItems(exposeeId: number, ownInventory: boolean): MLM.Item {
    return {
        id: exposeeId.toString(),
        type: getCompanyName(ownInventory),
        typePaid: getTypePaid(ownInventory),
        typePosition: 1,
    }
}

function buildMlmClickTrackingData(
    componentId: string,
    currentUrl: string,
    exposeeId: number,
    ownInventory: boolean,
): MLM.TrackingData {
    return {
        ...staticMlmTrackingData,
        page: MLMData.DEFAULT_PAGE as number,
        actionId: ActionIds.GENERAL_CLICK,
        componentId,
        pageUrl: currentUrl,
        items: [buildMlmItems(exposeeId, ownInventory)],
    }
}

function buildMapAnchorTrackingData(exposeeId: number): TrackingParameter {
    return {
        mslayer_element_data_id: TealiumTrackingIds.DETAIL_ACTIONS,
        mslayer_element_text: 'immobilien_expose',
        mslayer_element_type_text: 'link_adresse',
        mslayer_element_variant: 'default',
        mslayer_element_body_type: 'text_body',
        mslayer_element_position: NOT_SET,
        mslayer_element_company_name: NOT_SET,
        mslayer_element_count: NOT_SET,
        mslayer_element_detail_start_date: NOT_SET,
        mslayer_element_id: exposeeId.toString(),
    }
}

function buildTealiumFinanceLinkData(exposeeId: number): TrackingParameter {
    return {
        mslayer_element_data_id: TealiumTrackingIds.FINANCING_LINK_CLICK,
        mslayer_element_text: 'Baufinanzierung',
        mslayer_element_type_text: 'Linkklick Akkordeon',
        mslayer_element_variant: NOT_SET,
        mslayer_element_body_type: 'text_body',
        mslayer_element_position: NOT_SET,
        mslayer_element_company_name: NOT_SET,
        mslayer_element_count: NOT_SET,
        mslayer_element_detail_start_date: NOT_SET,
        mslayer_element_id: exposeeId.toString(),
    }
}

export function buildExpanderBoxTracking(exposeeId: number, variant: string): TrackingParameter {
    return {
        mslayer_element_data_id: TealiumTrackingIds.DETAIL_ACTIONS,
        mslayer_element_text: 'immobilien_expose',
        mslayer_element_variant: variant,
        mslayer_element_body_type: 'text_body',
        mslayer_element_company_name: NOT_SET,
        mslayer_element_count: NOT_SET,
        mslayer_element_id: exposeeId.toString(),
        mslayer_element_detail_start_date: NOT_SET,
        mslayer_element_position: NOT_SET,
    }
}
